import React from "react";
import { Button } from "../ui/Button";
import logger from "../../utils/logger";
import "./ErrorBoundary.css";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(_error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Anything logged here lands in stdout / DevTools; the runtime
    // environment is responsible for scraping it. No third-party error
    // tracker is wired into the app.
    logger.error("Error boundary caught an error", { error, errorInfo });

    this.setState({
      error,
      errorInfo,
    });
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null, errorInfo: null });
    window.location.href = "/";
  };

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <div className="error-boundary">
          <div className="error-boundary-content">
            <h1>Oops! Something went wrong</h1>
            <p>
              We&apos;re sorry for the inconvenience. The application encountered an unexpected
              error.
            </p>
            {process.env.NODE_ENV === "development" && this.state.error && (
              <details style={{ whiteSpace: "pre-wrap", marginTop: "20px" }}>
                <summary>Error Details (Development Only)</summary>
                <p>{this.state.error.toString()}</p>
                <p>{this.state.errorInfo?.componentStack}</p>
              </details>
            )}
            <Button variant="accent" size="lg" onClick={this.handleReset}>
              Return to Home
            </Button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
